export const RemoveCustomFieldRepository = Symbol.for('RemoveCustomFieldRepository');
